module.exports = __webpack_public_path__ + "img/logo.debb6a63.png";